import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { DialogService } from '../../../_services/dialog.service';
import { AuthService } from '../../../_services/auth.service';
import { DatePipe } from '@angular/common';
import { PhotoService } from '../../../_services/photo.service';
import { PledgePerWinTeam } from '../../../_models/fundraising/ppw/PledgePerWinTeam';
import { PledgePerWinService } from '../../../_services/fundraising/pledgePerWin.service';

@Component({
  selector: 'app-team-create',
  templateUrl: './team-create.component.html',
  styleUrls: ['../../cue5050/cue5050-create.component.css']
})
export class TeamCreateComponent implements OnInit, AfterContentChecked {

  public form: FormGroup;

  public formControls(name: string)  {
    return this.form.controls[name];
  }

  public eventFormControls(name: string)  {
    return (this.form.controls.event as FormGroup)?.controls[name];
  }

  public team: PledgePerWinTeam;
  public teamId: number;
  public vendorName: string;

  public hasValidationErrors: boolean;
  public showAdvancedOptions: boolean;

  public cloning = false;
  public viewing = false;

  constructor(
    private ppwService: PledgePerWinService,
    private authService: AuthService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private cdRef: ChangeDetectorRef,
    private datePipe: DatePipe,
    private imageService: PhotoService
  ) { }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges()
  }

  ngOnInit(): void {
    this.route.params
      .subscribe(params => {
        this.teamId = params['id'];

        this.ppwService.getTeamById(this.teamId ?? 0)
          .subscribe(teamData => {
            this.team = teamData;
            this.createForm(this.team);
          })
      });
  }

  createForm(team: PledgePerWinTeam) {
    this.form = this.fb.group({
        teamId: [team?.teamId || 0],
        name: [team?.name || '', [Validators.required, Validators.maxLength(30)]],
        logoUrl: [team?.logoUrl || '', [Validators.required]],
        sport: [team?.sport || '', [Validators.required, Validators.maxLength(30)]],
        description: [team?.description || '']
    });
  }

  compare(val1, val2) {
    return val1 === val2;
  }

  getVendorName() {
    return localStorage.getItem('vendorName');
  }

  uploadImage (file: File) {
    if (file && !file.type.includes('image')){
      this.form.controls.logoUrl.setErrors({ formatError: true });
      this.form.controls.logoUrl.markAsTouched();
      return
    }
    this.imageService.meetsImageConstraints(file, 240, 240, 1, 0.01)
      .subscribe(
        res => {

          if (res) {

            this.imageService.enqueueUploadPhoto(file, 'logo-image', { height: 240, width: 240 }, false, false)
            .subscribe(
              res => {

                this.form.patchValue({ logoUrl: res.url });
                this.form.markAsDirty();
              }
            );

          } else {

            this.form.controls.logoUrl.setErrors({ invalid: true });
            this.form.controls.logoUrl.markAsTouched();
          }
        }
      );
  }

  save() {
    this.hasValidationErrors = !this.form.valid;
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    if (this.hasValidationErrors) {
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }

    this.spinner.show();

    this.imageService.commitUploads()
      .subscribe(_ => {
        const teamData = new PledgePerWinTeam(this.form.getRawValue());

        if(this.teamId > 0) {
          this.ppwService.updateTeam(teamData).subscribe(
            () => {
              this.spinner.hide();
              this.navigateUp();
            },
            error => {
              this.spinner.hide();
              this.dialogService.error(error, "Unable to update team", this.viewRef);
            }
          );
        } else {
          this.ppwService.createTeam(teamData).subscribe(
            () => {
              this.spinner.hide();
              this.navigateUp();
            },
            error => {
              this.spinner.hide();
              this.dialogService.error(error, "Unable to create team", this.viewRef);
            }
          );
        }
      });
  }

  public navigateUp() {
    this.router.navigate([this.teamId > 0 ? '../../' : '../'], {relativeTo: this.route});
  }

}
